import { createSelector } from '@ngrx/store';
import { selectFeatureStore } from './generic.selectors';

export const selectAdvancePreferences = createSelector(
  selectFeatureStore,
  ({ advancePreferences }) => advancePreferences,
);

export const selectShowAdvanceOptInPossibility = createSelector(
  selectAdvancePreferences,
  (advancePreferences) =>
    advancePreferences.isLoaded && advancePreferences.advanceShiftsOptInEnabled,
);

export const selectShowAdvanceContent = createSelector(
  selectAdvancePreferences,
  (advancePreferences) =>
    advancePreferences.isLoaded &&
    advancePreferences.advanceShiftsOptInEnabled &&
    advancePreferences.advanceShiftsEnabled,
);
